import React, { useState, Fragment, useEffect } from 'react';
import {
    Row, Button, Card,
    CardBody, CustomInput,
    FormGroup,
    Label,
    InputGroupAddon,
    InputGroupText,
    Input,
    InputGroup
} from "reactstrap";
import { Colxx } from "../../../../../components/common/CustomBootstrap";

export default function AiEmailAssistant({
    templateData,
    updateTemplateData,
    assistantList,
    clickEnd,
    submit,
    isSuccess
}) {

    return (
        <div className="mb-4 ml-4">
            <Row>

                {/* ---------- AI EMAIL ASSISTANT ENABLED ---------- */}
                <Colxx sm={12} className="mb-2">
                    <h5>AI Email Assistant</h5>

                    <FormGroup>
                        <CustomInput
                            type="checkbox"
                            id="isEmail"
                            checked={true}
                            disabled={true}
                            label="AI Email Assistant"
                        />
                    </FormGroup>
                </Colxx>

                {/* ---------- DYNAMIC FLOW ---------- */}
                {assistantList && assistantList.length > 0 && (
                    <Colxx xxs="12" className="mb-4">
                        <Label style={{ fontSize: "14px" }}>Dynamic Conversation Flow</Label>

                        <Input
                            className="w-40"
                            type="select"
                            name="dynamicConversationFlow"
                            value={templateData.dynamicFlowId || ""}
                            onChange={(e) =>
                                updateTemplateData(
                                    "dynamicFlowId",
                                    e.target.value || null
                                )
                            }
                        >
                            <option value="">
                                Select a Dynamic Conversation Flow
                            </option>

                            {assistantList.map((assist, index) => (
                                <option key={index} value={assist.openAiAssistantId}>
                                    {assist.name} ({assist.openAiAssistantId})
                                </option>
                            ))}
                        </Input>
                    </Colxx>
                )}

                {/* ---------- SUBMIT ---------- */}
                <Colxx xxs="12" className="mb-4 mt-4 text-right">
                    {isSuccess ?
                        <Button
                            color="primary"
                            size="lg"
                            outline
                            className=" mr-1"
                            onClick={clickEnd}
                        >
                            Next
                        </Button>
                        :
                        <div> <Button
                            color="secondary"
                            size="lg"
                            outline
                            className="mr-2"
                            onClick={clickEnd}
                        >
                            Skip
                        </Button>

                            <Button
                                color="primary"
                                size="lg"
                                outline
                                onClick={submit}
                            >
                                Create AI Email Assistant
                            </Button>
                        </div>
                    }
                </Colxx>

            </Row>
        </div>
    );
}